/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Leave_Open_TextInputs */

const en_render_audio_leave_open_text = /** @type {(inputs: Render_Audio_Leave_Open_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please leave this window open until rendering completes`)
};

const fr_render_audio_leave_open_text = /** @type {(inputs: Render_Audio_Leave_Open_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez laisser cette fenetre ouverte jusqu'a la fin du rendu`)
};

const de_render_audio_leave_open_text = /** @type {(inputs: Render_Audio_Leave_Open_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte lassen Sie dieses Fenster geöffnet, bis der Rendering-Vorgang abgeschlossen ist.`)
};

const it_render_audio_leave_open_text = /** @type {(inputs: Render_Audio_Leave_Open_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si prega di lasciare aperta questa finestra fino al completamento del rendering`)
};

const ru_render_audio_leave_open_text = /** @type {(inputs: Render_Audio_Leave_Open_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, оставьте это окно открытым до завершения рендеринга.`)
};

const es_render_audio_leave_open_text = /** @type {(inputs: Render_Audio_Leave_Open_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deje esta ventana abierta hasta que se complete la renderización.`)
};

const zh_cn2_render_audio_leave_open_text = /** @type {(inputs: Render_Audio_Leave_Open_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请保持此窗口打开，直到渲染完成。`)
};

const ja_render_audio_leave_open_text = /** @type {(inputs: Render_Audio_Leave_Open_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レンダリングが完了するまでこのウィンドウを開いたままにしてください`)
};

const hi_render_audio_leave_open_text = /** @type {(inputs: Render_Audio_Leave_Open_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया रेंडरिंग पूरी होने तक इस विंडो को खुला रखें।`)
};

const pt_pt2_render_audio_leave_open_text = /** @type {(inputs: Render_Audio_Leave_Open_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, deixe esta janela aberta até que a renderização seja concluída.`)
};

/**
* | output |
* | --- |
* | "Please leave this window open until rendering completes" |
*
* @param {Render_Audio_Leave_Open_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_leave_open_text = /** @type {((inputs?: Render_Audio_Leave_Open_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Leave_Open_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_render_audio_leave_open_text(inputs)
	if (locale === "de") return de_render_audio_leave_open_text(inputs)
	if (locale === "it") return it_render_audio_leave_open_text(inputs)
	if (locale === "ru") return ru_render_audio_leave_open_text(inputs)
	if (locale === "es") return es_render_audio_leave_open_text(inputs)
	if (locale === "zh-CN") return zh_cn2_render_audio_leave_open_text(inputs)
	if (locale === "ja") return ja_render_audio_leave_open_text(inputs)
	if (locale === "hi") return hi_render_audio_leave_open_text(inputs)
	if (locale === "pt-PT") return pt_pt2_render_audio_leave_open_text(inputs)
	return en_render_audio_leave_open_text(inputs)
});